import React from 'react';
import Skeleton from "react-loading-skeleton";
import {useLocation} from "react-router-dom";

const AdminDashboardTableSkeleton = ({location}) => {
    return (
        <tr>
            {location === "/admin-dashboard" && (
                <>
                    <td><Skeleton height={16} width={100}/></td>
                    <td><Skeleton height={16} width={100}/></td>
                    <td><Skeleton height={16} width={100}/></td>
                    <td><Skeleton height={16} width={100}/></td>
                    <td><Skeleton height={16} width={100}/></td>
                    <td><Skeleton height={16} width={100}/></td>
                </>
            )}
        </tr>
    );
};

const AdminTableSkeleton = () => {
    const location = useLocation();
    let list = [];
    for (let i = 1; i <= 4; i++) {
        list.push(<AdminDashboardTableSkeleton location={location.pathname} key={i}/>)
    }
    return list;
}

export default AdminTableSkeleton;